import React, { forwardRef, useRef } from "react";
import { StyledModal, StyledModalHandle } from "@constants/Themed";
import GenerateSchemaForm from '@hooks/generateSchemaForm';
import { useDispatch, useSelector } from "react-redux";
import { DefaultRootState, } from "@reduxLocal/persistState";
import { SHOW_AUTH_MODAL } from "@reduxLocal/actions/types";
import apis from "@api/api";

type AddDepartmentModalProps = {
  submitFunction?: (values: any) => void;
}

const AddDepartmentModal = forwardRef<StyledModalHandle, AddDepartmentModalProps>((props, ref) => {
  const { submitFunction } = props;
  const socket = useSelector((state: DefaultRootState) => state.navigation.userHierarchySocket);
  const dispatch = useDispatch();

  const submitAddDepartment = async (values) => {
    console.log(values);
    await apis.addDepartment(values);
  }

  const addDepartment = {
    department_name: { validation: { required: true }, type: "text", helpText: "Enter the name of the department or group you wish to create" },
    department_description: { validation: { required: true, multiline: true }, type: "text", helpText: "Department Description", ref: "multiline" },
    permissions: { validation: { required: true }, type: "text", ref: "permissions" },
    department_head: { type: "team", ref: "team" },
  }

  return (
    <StyledModal modalRef={ref} animation={require("@assets/animations/1865-shooting-stars-outline-edited.json")} title="Add New Department" caption="Add a new department to your company and organise your current list of users." ref={ref}>
      <GenerateSchemaForm extraCallBack={()=>{
        ref.current?.closeModal();
      }} Progress schema={addDepartment} nullify={[]} submitFunction={submitFunction || submitAddDepartment} />
    </StyledModal>
  )
})

export default AddDepartmentModal;